import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=1ee58dda&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=1ee58dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee58dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee58dda')) {
      api.createRecord('1ee58dda', component.options)
    } else {
      api.reload('1ee58dda', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=1ee58dda&scoped=true&", function () {
      api.rerender('1ee58dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IXr1IdiIpoHs/JS/comp/DocBox.vue"
export default component.exports